module.exports = __webpack_public_path__ + "img/eb7b05a.png";